<template>
  <div
    class="row pa-0 ma-0 skip-capture header z-index-100 bg-main-dark"
    :class="{ 'tester-indicator': window.is_user_tester }"
  >
    <div class="col-12 pa-0 ma-0" v-if="window.is_user_tester">
      <div class="tester-indicator"></div>
    </div>
    <div class="col-12 pa-0 ma-0 d-flex shadow-sm align-center z-index-100">
      <a
        title="Functionize"
        :href="$router.resolve({ name: 'Projects' }).href"
        class="d-flex align-center justify-center header-logo h-100"
      >
        <img
          v-if="window.webLogo"
          class="h-100 pa-1"
          :src="window.webLogo.toString()"
          alt="Functionize Logo"
        />
        <FunctionizeLogo v-else />
      </a>
      <template v-if="isRbacAccess('Projects')">
        <router-link
          class="header-nav-link"
          :to="{ name: 'Projects' }"
          :class="{ 'exact-active': $route.name === 'Project' }"
          >Projects
        </router-link>
      </template>
      <PackageAccess
        module-name="BASICREPORTING"
        class="header-nav-link"
        v-if="isRbacAccess('Reports')"
      >
        <a href="/v2/insights-hub">Reports</a>
      </PackageAccess>
      <template v-if="isRbacAccess('Orchestrations') && boolean(window.orchestration_access)">
        <router-link class="header-nav-link" :to="{ name: 'Orchestrations' }">
          Orchestrations
        </router-link>
      </template>
      <template v-if="isRbacAccess('Extensions') && !boolean(window.hideExtensions)">
        <router-link class="header-nav-link" :to="{ name: 'Extensions' }">Extensions</router-link>
      </template>
      <PackageAccess
        module-name="TDM"
        class="header-nav-link"
        v-if="isRbacAccess('TDM') && !boolean(window.hideTDM)"
      >
        <router-link :to="{ name: 'TDM' }">TDM</router-link>
      </PackageAccess>
      <PackageAccess class="header-nav-link" v-if="window.enable_load_test">
        <router-link :to="{ name: 'LoadTest' }">Load</router-link>
      </PackageAccess>
      <template v-if="isRbacAccess('Team')">
        <router-link class="header-nav-link" :to="{ name: 'TeamList' }"> Team</router-link>
      </template>
      <v-menu
        v-if="boolean(window.adminrole)"
        offset-y
        :nudge-bottom="10"
        :nudge-left="70"
        v-model="moreMenu"
      >
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="d-flex align-center px-2 pl-5 relative">
            <UserIconPlain class="white--text scale-110 margin-top-2"></UserIconPlain>
            <div
              v-if="activeUser > 0"
              @click.exact.stop="showLoggedInUserDialog = true"
              class="rounded-circle white--text notification user-notification"
            >
              {{ activeUser }}
            </div>
          </div>
        </template>
        <v-list class="header-right-teamswitch-dropdown bg-white">
          <v-list-item-group>
            <v-list-item v-if="!boolean(window.reviewcommentadminrole)">
              <router-link class="text-main fs-13 w-100" :to="{ name: 'ManageUser' }">
                User Management
              </router-link>
            </v-list-item>
            <v-list-item>
              <router-link class="text-main fs-13 w-100" :to="{ name: 'CustomerDashboard' }">
                Customer Dashboard
              </router-link>
            </v-list-item>
            <PackageAccess module-name="BASICREPORTING">
              <v-list-item>
                <router-link class="text-main fs-13 w-100" :to="{ name: 'CustomerReport' }">
                  Customer Report
                </router-link>
              </v-list-item>
            </PackageAccess>
            <v-list-item v-if="boolean(window.emailtrackeraccessemailsFlag)">
              <router-link class="text-main fs-13 w-100" :to="{ name: 'EmailTracker' }">
                Email Tracker
              </router-link>
            </v-list-item>
            <v-list-item v-if="!window.disableNlpProcess">
              <router-link class="text-main fs-13 w-100" :to="{ name: 'ModelingFailedComments' }">
                Modeling Failed Comments
              </router-link>
            </v-list-item>
            <v-list-item v-if="boolean(window.isSignupAccess)">
              <router-link class="text-main fs-13 w-100" :to="{ name: 'Signup' }">
                Signup
              </router-link>
            </v-list-item>
            <!-- <v-list-item v-if="boolean(window.allowstreammanagement)">
              <router-link class="text-main fs-13 w-100" :to="{ name: 'RequestDemo' }">
                Request Demo
              </router-link>
            </v-list-item> -->
            <v-list-item v-if="boolean(window.is_resources_access)">
              <router-link class="text-main fs-13 w-100" :to="{ name: 'Resource' }">
                Resources
              </router-link>
            </v-list-item>
            <v-list-item v-if="!window.disableNlpProcess">
              <router-link class="text-main fs-13 w-100" :to="{ name: 'ReviewTests' }">
                Review NLP Tests
              </router-link>
            </v-list-item>
            <v-list-item v-if="boolean(window.allowstreammanagement)">
              <router-link class="text-main fs-13 w-100" :to="{ name: 'RuntimeStream' }">
                Runtime Streams
              </router-link>
            </v-list-item>
            <v-list-item v-if="!boolean(window.reviewcommentadminrole)">
              <router-link class="text-main fs-13 w-100" :to="{ name: 'RuntimeVersion' }">
                Runtime Version
              </router-link>
            </v-list-item>
            <v-list-item v-if="!boolean(window.reviewcommentadminrole)">
              <router-link class="text-main fs-13 w-100" :to="{ name: 'ManageTeam' }">
                Team Management
              </router-link>
            </v-list-item>
            <v-list-item v-if="window.swappingUID !== window.login_user_id">
              <a class="text-main fs-13 w-100" :href="exitSessionUrl">Exit Session</a>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <v-menu
        v-if="[1, 2].includes(rbacRole)"
        offset-y
        :nudge-bottom="10"
        :nudge-left="30"
        v-model="rbacMenu"
      >
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on" class="d-flex align-center px-4">
            <SettingIcon class="white--text"></SettingIcon>
          </span>
        </template>
        <v-list class="header-right-teamswitch-dropdown bg-white">
          <v-list-item-group>
            <v-list-item v-if="rbacRole === 1">
              <router-link class="text-main fs-13" :to="{ name: 'SiteAdmin' }">
                Site Admin
              </router-link>
            </v-list-item>
            <v-list-item v-if="rbacRole === 2">
              <router-link class="text-main fs-13" :to="{ name: 'TeamAdmin' }">
                Team Admin
              </router-link>
            </v-list-item>
            <v-list-item>
              <router-link class="text-main fs-13" :to="{ name: 'ProjectAdmin' }">
                Project Admin
              </router-link>
            </v-list-item>
            <v-list-item v-if="boolean(window.isRBACManageAccess) || rbacRole === 1">
              <router-link class="text-main fs-13" :to="{ name: 'Roles' }">Roles</router-link>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <div v-if="!window.noheader" class="d-flex align-center ml-auto">
        <InternalPages v-if="window.is_user_tester" />

        <v-tooltip
          v-if="isConcurrentLimit && max_concurrent_test > 0"
          bottom
          nudge-top="15"
          :disabled="!isRbac || true"
          content-class="top-arrow"
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="text-white d-flex align-center fs-10 width-180" v-bind="attrs" v-on="on">
              <div class="row mx-2">
                <div class="col-12 pa-0 px-2">
                  <div class="d-flex align-center">
                    {{ test_run_count }}/{{ max_concurrent_test }} Running Flows
                    <v-icon v-if="isRbac && false" size="5px" class="px-1" dark>
                      mdi-alert-circle
                    </v-icon>
                  </div>
                </div>
                <div class="col-12 pa-0">
                  <v-progress-linear
                    color="#0072b1"
                    class="rounded-xl"
                    :value="runningTestCases"
                    height="15"
                  >
                    <span class="white--text">{{ runningTestCases }}%</span>
                  </v-progress-linear>
                </div>
              </div>
            </div>
          </template>
          <div class="d-block">
            <div class="min-width-160 max-width-160 fs-13">
              Dedicated Agents: {{ customer_assigned_quota }}
            </div>
            <div class="d-block min-width-160 max-width-160 fs-13">
              Available Open Pool : {{ current_open_pool }}
            </div>
          </div>
        </v-tooltip>

        <div v-else class="text-white fs-14 mx-2">{{ test_run_count }} Running Flows</div>

        <div v-if="expiredDays > 0" class="text-white fs-14 row mx-2 align-center">
          <ExpirationInner class="mx-1"></ExpirationInner>
          <div>Expired {{ expiredDays }} days ago</div>
        </div>

        <div v-if="updateButtonFlag" class="mx-2 max-width-40 lh-15">
          <a target="_blank" :href="pluginLink" class="text-white fs-13">
            <div>Update Plugin</div>
          </a>
        </div>

        <div v-if="isTeamSwitchDropdown" class="d-flex align-center px-3 bg-main min-height-42">
          <v-menu offset-y :nudge-bottom="10" v-model="teamMenu" max-height="70vh">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="d-flex align-center">
                <teamSwitchIcon class="scale-80"></teamSwitchIcon>
                <span class="text-white px-2 fs-14 select-none">{{ selectedTeam }}</span>
                <DownArrowIcon
                  :class="{ 'rotate-180': teamMenu }"
                  class="text-white"
                ></DownArrowIcon>
              </span>
            </template>
            <v-list class="header-right-teamswitch-dropdown bg-white">
              <v-list-item-group>
                <v-list-item v-for="(team, index) in userteamsarr" :key="index">
                  <v-list-item-title @click="switchTeam(team)" class="fs-13">
                    {{ team.name }}
                  </v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </div>

        <v-menu v-model="userMenu" offset-y :nudge-left="10" max-width="200">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-tooltip bottom open-delay="2000">
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    class="d-flex align-center bg-main height-41 px-3 select-none"
                  >
                    <UserIcon class="scale-80 mr-1"></UserIcon>
                    <div class="fs-14 text-white width-100">
                      <span class="ellipsis">{{ window.beaconusername }}</span>
                    </div>
                    <DownArrowIcon
                      class="text-white ml-2"
                      :class="{ 'rotate-180': userMenu }"
                    ></DownArrowIcon>
                  </div>
                </template>
                {{ window.beaconusername }}
              </v-tooltip>
            </div>
          </template>
          <v-list class="">
            <v-list-item-group>
              <v-list-item>
                <router-link
                  :to="{ name: 'MyProfileTab' }"
                  class="d-flex justify-space-between align-center text-main w-100"
                >
                  <span class="fs-12">My Profile</span>
                  <UserIconPlain></UserIconPlain>
                </router-link>
              </v-list-item>
              <v-list-item v-if="boolean(window.partner_admin)">
                <a
                  href="/partner"
                  class="d-flex justify-space-between align-center text-main w-100"
                >
                  <span class="fs-12">Partner Admin</span>
                  <UserIconPlain></UserIconPlain>
                </a>
              </v-list-item>
              <v-list-item>
                <a
                  href="https://support.functionize.com/hc/en-us/requests/new"
                  class="d-flex justify-space-between align-center text-main w-100"
                  target="_blank"
                >
                  <span class="fs-12">Support Portal</span>
                  <QuestionIcon></QuestionIcon>
                </a>
              </v-list-item>

              <PackageAccess module-name="DOCUMENTATION">
                <v-list-item>
                  <a
                    href="https://support.functionize.com/hc/en-us"
                    class="d-flex justify-space-between align-center text-main w-100"
                    target="_blank"
                  >
                    <span class="fs-12">Documentation</span>
                    <SupportIcon></SupportIcon>
                  </a>
                </v-list-item>
              </PackageAccess>

              <!--     Alerts      -->
              <v-list-item>
                <router-link
                  :to="{ name: 'Alerts' }"
                  class="d-flex justify-space-between align-center text-main w-100"
                >
                  <span class="fs-12">Alerts</span>
                  <BellIcon></BellIcon>
                </router-link>
              </v-list-item>
              <!--     Alerts      -->

              <!--     API Keys      -->
              <v-list-item v-if="boolean(window.moduleaccess?.apikeys?.access)">
                <router-link
                  :to="{ name: 'ApiKeys' }"
                  class="d-flex justify-space-between align-center text-main w-100"
                >
                  <span class="fs-12">API Keys</span>
                  <KeyIcon></KeyIcon>
                </router-link>
              </v-list-item>
              <!--     API Keys      -->

              <!--     API Documentation      -->
              <PackageAccess module-name="SWAGGERAPI">
                <v-list-item v-if="boolean(window.moduleaccess?.swagger?.access)">
                  <router-link
                    :to="{ name: 'ApiDocumentation' }"
                    class="d-flex justify-space-between align-center text-main w-100"
                  >
                    <span class="fs-12">API Documentation</span>
                    <BookIcon></BookIcon>
                  </router-link>
                </v-list-item>
              </PackageAccess>
              <!--     API Documentation      -->

              <!--     Proxy Settings      -->
              <v-list-item v-if="enableProxySettings">
                <router-link
                  :to="{ name: 'ProxySettingsTab' }"
                  class="d-flex justify-space-between align-center text-main w-100"
                >
                  <span class="fs-12">Proxy Settings</span>
                  <FlagIcon></FlagIcon>
                </router-link>
              </v-list-item>
              <!--     Proxy Settings      -->

              <v-list-item v-if="installButtonFlag">
                <a
                  :href="pluginLink"
                  target="_blank"
                  class="d-flex justify-space-between align-center text-main w-100"
                >
                  <span class="fs-12">Install Plugin</span>
                  <DownloadIcon />
                </a>
              </v-list-item>

              <v-list-item v-if="boolean(window.proxy_status_display) && window.is_user_tester">
                <ProxyStatus />
              </v-list-item>

              <!--     LogOut      -->
              <v-list-item>
                <div
                  @click="logout"
                  class="d-flex justify-space-between align-center text-main w-100"
                >
                  <span class="fs-12 pr-3">Logout</span>
                  <LogoutIcon></LogoutIcon>
                </div>
              </v-list-item>
              <!--     LogOut      -->
            </v-list-item-group>
          </v-list>
        </v-menu>
      </div>

      <div class="overlay" v-if="logoutLoader">
        <div class="loader">
          <functionize-loader></functionize-loader>
        </div>
      </div>
    </div>
    <LoggedInUserDialog
      v-if="boolean(window.adminrole)"
      @cancel="showLoggedInUserDialog = false"
      :show-dialog="showLoggedInUserDialog"
    ></LoggedInUserDialog>
  </div>
</template>

<script>
import LoggedInUserDialog from "@/components/dialogs/LoggedInUserDialog";
import FunctionizeLoader from "@/components/loader/FunctionizeLoader";
import { mapState } from "vuex";
import BellIcon from "../../assets/svg/BellIcon.svg";
import BookIcon from "../../assets/svg/BookIcon.svg";
import CodeIcon from "../../assets/svg/CodeIcon.svg";
import DownArrowIcon from "../../assets/svg/downArrow.svg";
import ExpirationInner from "../../assets/svg/expirationInner.svg";
import FlagIcon from "../../assets/svg/flag-variant.svg";
import FunctionizeLogo from "../../assets/svg/functionizeHeaderLogo.svg";
import KeyIcon from "../../assets/svg/keyIcon.svg";
import LogoutIcon from "../../assets/svg/LogoutIcon.svg";
import QuestionIcon from "../../assets/svg/QuestionIcon.svg";
import SettingIcon from "../../assets/svg/settingIcon.svg";
import SupportIcon from "../../assets/svg/SupportIcon.svg";
import teamSwitchIcon from "../../assets/svg/teamSwitchIcon.svg";
import UserIcon from "../../assets/svg/userIcon.svg";
import UserIconPlain from "../../assets/svg/userIconPlain.svg";
import ProxyStatus from "./ProxyStatus.vue";
import InternalPages from "./InternalPages.vue";
import DownloadIcon from "@/assets/svg/downloadIcon.svg";

export default {
  name: "GlobalHeader",
  components: {
    UserIconPlain,
    FunctionizeLoader,
    ExpirationInner,
    FunctionizeLogo,
    UserIcon,
    DownArrowIcon,
    teamSwitchIcon,
    LoggedInUserDialog,
    SettingIcon,
    QuestionIcon,
    SupportIcon,
    BellIcon,
    KeyIcon,
    BookIcon,
    FlagIcon,
    CodeIcon,
    LogoutIcon,
    ProxyStatus,
    InternalPages,
    DownloadIcon,
  },
  data: () => ({
    rbacMenu: false,
    moreMenu: false,
    teamMenu: false,
    userMenu: false,
    logoutLoader: false,
    activeTask: 0,
    activeUser: 0,
    userteamsarr: [],
    installButtonFlag: false,
    updateButtonFlag: false,
    showLoggedInUserDialog: false,
    test_run_count: 0,
    customer_assigned_quota: 0,
    current_open_pool: 0,
    max_concurrent_test: 0,
    isConcurrentLimit: false,
    runningCount: 0,
    pluginLink: window.chromeStorePlugin,
    selectedTeam: "",
    isTeamSwitchDropdown: false,
    publicPath: process.env.BASE_URL,
    reportRoutes: [
      {
        name: "ExecutiveDashboard",
        title: "Executive Dashboard",
        access: "executivedashboardreport",
        is_tester: true,
      },
      {
        name: "TestHealth",
        title: "Test Health",
        access: "generalreport",
        is_tester: false,
      },
      {
        name: "BrowserHealth",
        title: "Browser Health",
        access: "generalreport",
        is_tester: false,
      },
      {
        name: "Teams",
        title: "Teams",
        access: "teamreport",
        is_tester: true,
      },
      {
        name: "UsageQuota",
        title: "Usage & Quotas",
        access: "quotareport",
        is_tester: true,
      },
    ],
  }),
  computed: {
    ...mapState({
      window: (state) => state.window,
      messagesCount: (state) => state.messagesCount,
    }),
    isRbac() {
      return Boolean(this.window.current_site_id);
    },
    runningTestCases() {
      const result = parseInt((this.test_run_count / this.max_concurrent_test) * 100);
      if (result > 100) return 100;
      return result;
    },
    rbacRole() {
      return parseInt(this.window.role_level);
    },
    is_turk_test() {
      return this.window.is_turk_test;
    },
    expiredDays() {
      try {
        const difference = new Date() - new Date(this.window.expiration_date);
        return Math.floor(difference / (1000 * 60 * 60 * 24));
      } catch (e) {
        return -1;
      }
    },
    exitSessionUrl() {
      return `/account/login/autologin?id=${this.window.swappingUID}&tempadmin=1&existsession=1`;
    },
    reportsRoute() {
      return (
        this.reportRoutes
          .filter((report) => {
            if (report?.is_tester) {
              return this.window.is_user_tester;
            }
            return true;
          })
          .filter((report) => {
            if (!this.window?.enableExecutiveDashboardReport) {
              return false;
            }
            return ["1", "2", ""].includes(
              this.window?.moduleaccess[report.access]?.access?.toString()
            );
          })[0]?.name ?? "TestHealth"
      );
    },
    enableProxySettings() {
      return this.boolean(this.window?.moduleaccess?.proxysettings?.access);
    },
  },
  methods: {
    isRbacAccess(module) {
      if (!this.window.current_site_id) {
        if (module === "Team") {
          return this.window.teamowner;
        }
        return true;
      }
      switch (module) {
        case "Projects":
          return this.boolean(this.window.moduleaccess?.viewproject?.access);
        case "Reports":
          return this.boolean(this.window.moduleaccess?.generalreport?.access);
        case "Orchestrations":
          return this.boolean(this.window.moduleaccess?.vieworchestration?.access);
        case "Extensions":
          return this.boolean(this.window.moduleaccess?.extensions?.access);
        case "TDM":
          return this.boolean(this.window.moduleaccess?.viewtdm?.access);
        case "Team":
          if (this.window.teamowner) {
            return true;
          }
          return this.boolean(this.window.moduleaccess?.manageteam?.access);
        default:
          return true;
      }
    },
    addActiveClass(_name) {
      const name = (_name ?? "").toString();
      if (name.startsWith("Project") && window.location.pathname.includes("project")) {
        return true;
      }
      if (name.length > 1) {
        return window.location.pathname.includes(name.toLowerCase());
      }
      return false;
    },
    switchTeam(team) {
      this.$store.dispatch("switchTeam", {
        team: team,
        onCancel: undefined,
      });
    },
    logout() {
      if (window.ChurnZero) {
        window.ChurnZero.push(["trackEvent", "Logout"]);
        window.ChurnZero.push(["stop"]);
      }
      this.logoutLoader = true;
      this.$http
        .post("/account/logout", this.formData({ CSRFToken: this.window.CSRFToken }))
        .catch(() => {
          this.logoutLoader = false;
        })
        .finally(() => {
          this.logoutLoader = false;
          window.location.replace("/v1/login/");
          localStorage.clear();
          // this.$router.replace({ name: "Login" });
        });
      // sessionStorage.clear();
      // document.cookie = "logout=true; path=/; logout-time=" + new Date().getTime();
    },
    async getActiveUser() {
      this.J_POST("/account/settings/getloggedinusercount").then((data) => {
        this.activeUser = data?.response?.loggedinUserCount ?? 1;
      });
    },
    checkPlugInStatus(isChrome, isPluginInstalled, validPlugin) {
      if (isChrome) {
        setTimeout(() => {
          this.updateButtonFlag = isPluginInstalled && !validPlugin;
          this.installButtonFlag = !isPluginInstalled;
        }, 500);
      }
    },
    initHeader() {
      const { isChrome, isPluginInstalled, validPlugin } = this.checkInstallPlugin();
      this.checkPlugInStatus(isChrome, isPluginInstalled, validPlugin);

      this.getUserTeam();
    },

    //check for valid installed plugin version
    //Get all accessible teams list
    getUserTeam() {
      this.userteamsarr = this.alwaysObject(this.window.userteamsarr);
      if (Object.keys(this.userteamsarr).length > 1) {
        this.isTeamSwitchDropdown = true;
      }
      for (const prop in this.userteamsarr) {
        if (this.userteamsarr[prop].selected) {
          this.selectedTeam = this.userteamsarr[prop].name;
        }
      }
    },
    //Get current running tests,maximum concurrent limit and set progress bar
    currentTestRunning() {
      if (this.window.pageobject_id && this.window.pageobject_id > 0) {
        return;
      }
      const payload = this.formData({
        CSRFToken: this.window.CSRFToken,
      });

      this.J_POST("/account/settings/getloggedinteamrunningtests", payload).then((result) => {
        if (result.status === "success") {
          this.isConcurrentLimit = true;
          this.max_concurrent_test = result.response.max_concurrent_test;
          this.test_run_count = result.response.test_run_count;
          this.current_open_pool = result.response?.current_open_pool ?? 0;
          this.customer_assigned_quota = result.response?.customer_assigned_quota ?? 0;
        } else {
          this.isConcurrentLimit = false;
        }
      });
    },
  },
  created() {
    // this.$store.dispatch("getWindowVar");
    this.initHeader();
    this.currentTestRunning();
    setInterval(() => {
      if (window.TAB_ACTIVE) this.currentTestRunning();
    }, 30000);
    this.getActiveUser();
    this.activeTask = this.window?.taskCount || 0;
  },
  watch: {
    $route(_old, _new) {
      if (_old.name !== _new.name) {
        this.$store.dispatch("getWindowVar");
        const { isChrome, isPluginInstalled, validPlugin } = this.checkInstallPlugin();
        this.checkPlugInStatus(isChrome, isPluginInstalled, validPlugin);
      }
    },
  },
};
</script>

<style lang="scss">
.header {
  height: 43px;

  &.tester-indicator {
    height: 46px;
  }
}

.header-nav-link {
  background-color: #4b466f;
  padding: 9px 10px;
  color: white !important;
  position: relative;

  a {
    color: white !important;

    &.exact-active,
    &.active {
      &:after {
        content: "";
        position: absolute;
        width: 100%;
        height: 5px;
        background-color: #0e72b1;
        bottom: 0;
        left: 0;
        border-radius: 2px;
      }
    }

    &:hover {
      background-color: #5d5881;
    }
  }

  &.exact-active,
  &.active {
    &:after {
      content: "";
      position: absolute;
      width: 100%;
      height: 5px;
      background-color: #0e72b1;
      bottom: 0;
      left: 0;
      border-radius: 2px;
    }
  }

  &:hover {
    background-color: #5d5881;
  }
}

.tester-indicator {
  height: 4px;
  background: #0e72b1;
}
</style>
